module.exports = __webpack_public_path__ + "media/img/help_center/Institution_User_Settings_05-88cfa4280ff1e22cd50afe687f283b8f.jpg";